import { isCFColor as _isCFColor } from './is-color';
import { getCFColorValue as _getCFColorValue } from './get-color-value';
import * as SEMANTIC from './semantic';
import * as SWATCHBOOK from './swatchbook';
export const COLOR = Object.assign(Object.assign({}, SWATCHBOOK), SEMANTIC);
export const getCFColorValue = _getCFColorValue;
export const isCFColor = _isCFColor;
